import { useParams, useNavigate } from "react-router-dom";

function PdfViewer() {
    const { name } = useParams();
    const navigate = useNavigate();

    return (
        <div>
            <button className="btn btn-primary m-2" onClick={() => navigate(-1)}>
                ← Back
            </button>
            <div className="d-flex justify-content-center col-sm-12">
                <iframe
                    src={`/Assets/PDF/${name}.pdf`}
                    width="90%"
                    style={{ border: "none", height: "92vh" }}
                    title="PDF"
                />

            </div>
        </div>
    );
}

export default PdfViewer;
